// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plug-solid';

export const Component = () => (
  <path d='M22.636 23.073c0 .335-.191.526-.527.526h-9.818c-.67-.047-1.245-.287-1.724-.766-.479-.431-.719-1.006-.719-1.724v-2.443H7.406a1.41 1.41 0 0 1-1.054-.43 1.408 1.408 0 0 1-.43-1.055v-1.436h8.86v1.436c0 .431-.145.767-.432 1.054a1.408 1.408 0 0 1-1.054.431h-2.442v2.443c0 .43.144.766.431 1.053.288.288.623.432 1.006.432h9.818c.335 0 .526.143.526.479ZM17.703 7.89V5.927c0-.239-.096-.479-.287-.718a.946.946 0 0 0-.67-.288h-2.97V2.48c0-.335-.144-.479-.48-.479-.334 0-.478.144-.478.479v2.44H7.885V2.48c0-.335-.144-.479-.479-.479-.335 0-.479.144-.479.479v2.44h-2.97a.946.946 0 0 0-.67.288c-.19.239-.287.479-.287.718V7.89h14.703Zm0 5.364V8.848H3v4.407c0 .43.144.766.431 1.054.288.287.623.43 1.054.43H16.22a1.41 1.41 0 0 0 1.054-.43 1.41 1.41 0 0 0 .43-1.054Z' />
);

export const viewBox = '0 0 25 25';
